/**
 * @generated SignedSource<<8ca79c2de509ecd745336906c0b940c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MetaAdSetEffectiveStatus = "ACTIVE" | "ARCHIVED" | "CAMPAIGN_PAUSED" | "DELETED" | "IN_PROCESS" | "PAUSED" | "WITH_ISSUES" | "%future added value";
export type MetaAdSetStatus = "ACTIVE" | "ARCHIVED" | "DELETED" | "PAUSED" | "%future added value";
export type ListMetaAdSetRequest = {
  brandId: string;
  pageNumber?: number | null;
  pageSize?: number | null;
  search?: string | null;
};
export type AdSetAsyncMultiSelectQuery$variables = {
  input: ListMetaAdSetRequest;
};
export type AdSetAsyncMultiSelectQuery$data = {
  readonly listMetaAdSets: {
    readonly data: ReadonlyArray<{
      readonly campaignName: string | null;
      readonly effectiveStatus: MetaAdSetEffectiveStatus | null;
      readonly id: string;
      readonly metaAdAccount: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly name: string | null;
      readonly status: MetaAdSetStatus | null;
    }>;
  };
};
export type AdSetAsyncMultiSelectQuery = {
  response: AdSetAsyncMultiSelectQuery$data;
  variables: AdSetAsyncMultiSelectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MetaAdSetList",
    "kind": "LinkedField",
    "name": "listMetaAdSets",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MetaAdSet",
        "kind": "LinkedField",
        "name": "data",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "campaignName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetaAdAccount",
            "kind": "LinkedField",
            "name": "metaAdAccount",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "effectiveStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdSetAsyncMultiSelectQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdSetAsyncMultiSelectQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "b536ca2a08ab4d4e9fa47dcee2e2db3c",
    "id": null,
    "metadata": {},
    "name": "AdSetAsyncMultiSelectQuery",
    "operationKind": "query",
    "text": "query AdSetAsyncMultiSelectQuery(\n  $input: ListMetaAdSetRequest!\n) {\n  listMetaAdSets(input: $input) {\n    data {\n      id\n      name\n      campaignName\n      metaAdAccount {\n        id\n        name\n      }\n      effectiveStatus\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "983a18a1e7c4ca48e6e5f896a97d9ddf";

export default node;
